import Styled from 'styled-components'

export const Brand = Styled.h1`
`

export const Banner = Styled.div`
`

export const CotainerProduct = Styled.div`
`

export const Cashback = Styled.div`
`
export const Space = Styled.div`
`

export const SearchResultText = Styled.span`
  font-weight: bold;
  font-size: ${props => props.hasDidYouMean ? '13px' : '14px'};
`;

export const DidYouMeanText = Styled.span`
  font-weight: bold;
  font-size: 14px;
`;
